function Pagination(params) {
  // params.currentPage must be an observable (not just the value).
  this.currentPage = params.currentPage;
  // params.pages must be an observable (not just the value).
  this.pages = params.pages;
}

Pagination.prototype.toStart = function() {
  this.currentPage(1);
};

Pagination.prototype.toEnd = function() {
  this.currentPage(this.pages());
};

Pagination.prototype.nextPage = function() {
  if (this.currentPage() < this.pages()) {
    this.currentPage(parseInt(this.currentPage()) + 1);
  }
};

Pagination.prototype.previousPage = function() {
  if (this.currentPage() > 1) {
    this.currentPage(parseInt(this.currentPage()) - 1);
  }
};

module.exports = Pagination;
